import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Estilos
import styles from './sidebar.module.css';

// Constantes
import menuData from '../../constants/menuData';

// Ícones fixos
import { GoHome } from "react-icons/go";

function Sidebar() {
    const { logout, isAuthenticated } = useAuth();
    const location = useLocation();

    const normalize = (p) => p.replace(/\/+$/, '');

    const isActive = (path) => {
        const current = normalize(location.pathname);
        const target = normalize(path);
        return current === target || current.startsWith(`${target}/`);
    };

    if (
        !isAuthenticated ||
        location.pathname === '/' ||
        location.pathname.startsWith('/res') ||
        location.pathname.startsWith('/participante')||
        location.pathname.startsWith('/ead')
    ) return null;

    return (
        <div className={styles.sidebar}>
            <nav className={styles.menu}>

                {/* Botão fixo Home */}
                {isActive('/home') ? (
                    <button className={`${styles.link} ${styles.disabled}`} disabled>
                        <GoHome className={styles.icon} />
                        <span>Home</span>
                    </button>
                ) : (
                    <Link to="/home" className={styles.link}>
                        <GoHome className={styles.icon} />
                        <span>Home</span>
                    </Link>
                )}

                {/* Botões do menu dinâmico */}
                {menuData.map((grupo, index) =>
                    grupo.botoes.map((btn, i) => (
                        isActive(btn.link) ? (
                            <button key={`${index}-${i}`} className={`${styles.link} ${styles.disabled}`} disabled>
                                <btn.icone className={styles.icon} />
                                <span>{btn.nome}</span>
                            </button>
                        ) : (
                            <Link key={`${index}-${i}`} to={btn.link} className={styles.link}>
                                <btn.icone className={styles.icon} />
                                <span>{btn.nome}</span>
                            </Link>
                        )
                    ))
                )}

            </nav>
        </div>
    );
}

export default Sidebar;